import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogComponent } from '../component/dialog/dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private _matDialog: MatDialog) {}

  open(args: {
    content: string;
    title: string;
    onConfirm?: () => void;
    confirmText?: string;
    config?: MatDialogConfig;
  }) {
    const formattedData = {
      onConfirm: () => {},
      ...args,
    };

    this._matDialog.open(DialogComponent, {
      hasBackdrop: true,
      data: formattedData,
      maxWidth: 500,
      minWidth: 400,
      ...(args.config || {}),
    });
  }
}
